<template>
  <div class="flex flex-1 flex-col">
    <MRow :gutter="0">
      <MCol :size="12">
        <MRow :gutter="0" class="flex-1">
          <MCol v-for="item in items" :key="item.id" :size="3">
            <MRow :gutter="0">
              <MCol class="mx-2 text-ellipsis">
                <FlotoFormItemReadOnly :label="item.oidLabel">
                  <span :title="item.value">{{ item.value || '---' }}</span>
                </FlotoFormItemReadOnly>
              </MCol>
            </MRow>
          </MCol>
        </MRow>
      </MCol>
    </MRow>
  </div>
</template>

<script>
import { getSnmpPropertyValueApi } from '../../asset-api'
export default {
  name: 'ScalarPropertyValueTab',
  props: {
    resourceId: { type: Number, required: true },
  },
  data() {
    return {
      items: [],
    }
  },
  created() {
    this.getValueDetails()
  },
  methods: {
    getValueDetails() {
      getSnmpPropertyValueApi(this.resourceId, 'scalar').then((data) => {
        this.items = data.items
      })
    },
  },
}
</script>
